<template>
  <router-view></router-view>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/list",
        selectedOutcome: "general/selectedOutcome",
        currentUserData: "auth/currentUserData",
      }),
    },
    props: {
      source: String,
    },
    watch: {
      $route: function () {
        this.handleRoute();
      },
    },
    data: () => ({}),
    mounted() {
      this.$store.dispatch("outcomes/loadAll");
    },
    methods: {
      handleRoute() {},
    },
  };
</script>
